// extracted by mini-css-extract-plugin
module.exports = {"container":"table-detail-toolbar_container__180KA","button-container":"table-detail-toolbar_button-container__LE3km","size-container":"table-detail-toolbar_size-container__ItHos"};